import { AMLS_COMMON } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';

export const COMMON_CONSTANTS = {
  BASE_URL: AMLS_COMMON,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    Authorization: `${TOKEN_ID}`
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData'
};
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const FRAUD_PREVENTION_SOURCE_IDS = [25, 29];
